import React, { useEffect, useState } from 'react';
import api from '../services/apiService';

export default function HpExportStatus({ refresh = 0, connection = false }) {
  const [status, setStatus] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    const load = async () => {
      try {
        const response = await api.get('/exportHp/status');
        if (active) { setStatus(response.data); setError(''); }
      } catch (err) { if (active) setError(err.response?.data?.error || 'HP-Exportstatus konnte nicht geladen werden.'); }
    };
    load();
    const timer = setInterval(load, 5000);
    return () => { active = false; clearInterval(timer); };
  }, [refresh]);
  return <section aria-label="HP-Exportstatus">
    {error && <p role="alert">{error}</p>}
    {status && <>
      <p>{status.pending ? 'Die vollständige JSON-Datei wird aktualisiert.' : 'Vollständige JSON-Datei erstellt.'}
        {' '}{status.itemCount} Maschinen · Stand {status.revision}
        {status.generatedAt && <> · {new Date(status.generatedAt).toLocaleString('de-DE')}</>}</p>
      {status.error && <p role="alert">{status.error}</p>}
      {!status.tokenConfigured && <p>Für den Abruf durch die Homepage muss der Zugriffstoken in der Serverkonfiguration eingerichtet werden.</p>}
      {connection && <>
        <p>Abrufadresse: <code>{(api.defaults.baseURL || '').replace(/\/$/, '')}{status.downloadPath}</code></p>
        <p>Die Homepage ruft diese Datei serverseitig über HTTPS mit ihrem HP-Zugriffstoken ab. Der Token wird in der Serverkonfiguration verwaltet.</p>
      </>}
    </>}
  </section>;
}
